import React from 'react'
import PropTypes from 'prop-types'
import header from '../assets/bank-assets/background.jpg'
import { useTranslation } from "react-i18next";

function BreadcrumbsHome({ children }) {
    const arr = Array.from(children);

    // eslint-disable-next-line
    const { t, i18n } = useTranslation();

    const changeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    return (
        <>
            <section className="bg-contain w-full" style={{
                backgroundImage: `url(${header})`
            }}>
                <div className="flex flex-col lg:flex-row justify-center items-center text-right py-8 md:py-16">
                    {
                        arr.reverse().map((child, i) => (
                            <span key={i}
                                className={`text-xl md:text-xl lg:text-2xl mx-12 py-4 lg:py-0 tracking-wider  capitalize ${arr.length - 1 !== i ? 'text-white font-light' : 'text-white font-semibold'}`}>
                                {child}
                            </span>
                        ))
                    }
                </div>
            </section>
        </>

    );
}

BreadcrumbsHome.propTypes = {
    children: PropTypes.node.isRequired
}

export default BreadcrumbsHome